import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const ReloadIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 8, height = 8, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.96604 5.52034C8.87162 6.24032 8.583 6.92101 8.13112 7.48942C7.67925 8.05783 7.08117 8.49252 6.40102 8.74685C5.72088 9.00119 4.98433 9.06558 4.27037 8.93313C3.55641 8.80068 2.89197 8.47637 2.34832 7.995C1.80466 7.51362 1.4023 6.89334 1.18438 6.20066C0.966458 5.50799 0.941202 4.76907 1.11132 4.06313C1.28144 3.3572 1.64051 2.71089 2.15003 2.19352C2.65955 1.67615 3.30029 1.30723 4.00354 1.12634C5.95304 0.626339 7.97104 1.62984 8.71604 3.49984M8.99954 0.999832V3.49983H6.49954"
          stroke="#47A0FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
